import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import * as S from './styles';

import Header from '../../molecules/Header';
import NavBar from '../../molecules/NavBar';
import MainContent from '../../molecules/MainContent';
import Footer from '../../molecules/Footer';
import ProfileCardMenu from '../../organisms/ProfileCardMenu';
import TabsContainer from '../../molecules/TabsContainer';
import FavouritesTab from '../../organisms/FavouritesTab';

function UserFavorites() {
  return (
    <S.Container>
      {useSelector((state) => state.auth.user_logged_in) < 1 ? <Redirect to="/entrar" /> : null}
      <Header />
      <NavBar />
      <MainContent>
        <S.UserSoldContainer>
          <ProfileCardMenu />

          <TabsContainer
            icon_code="far fa-star"
            title="FAVORITOS"
            tabs={[{ title: ' ', url: '#' }]}>
            <FavouritesTab tabId="favourites_tab" />
          </TabsContainer>
        </S.UserSoldContainer>
      </MainContent>
      <Footer />
    </S.Container>
  );
}

export default UserFavorites;
